export default __webpack_public_path__ + "static/media/Screenshot (1070).60e1948a.png";